var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"foamtree_render",staticClass:"example",staticStyle:{"height":"380px"},attrs:{"id":"foamtreehtml","justify":"center"}})
}
var staticRenderFns = []

export { render, staticRenderFns }